/**
 * @returns {RegExp}
 */
function postalCode () {
  return /^[0-9]{3} ?[0-9]{2}$/
}

module.exports = { postalCode }
